const uuidRegex = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}$/i

export function isUuid(src: string) {
  return uuidRegex.test(src)
}

export function uuidShort(uuid: string) {
  return uuid.slice(-12)
}

export function titleCase(x: string) {
  return x.trim().replace(/\w+/g, (word) => word[0].toUpperCase() + word.substring(1).toLowerCase())
}

export function formattedTelephone(
  telephone: string | undefined | null,
  prefixLength: number = 3,
  { hidePrefix } = { hidePrefix: false },
) {
  if (!telephone) {
    return undefined
  }
  const payload = telephone.toString().replace(/ /g, '').slice(prefixLength)
  const prefix = hidePrefix ? undefined : telephone.slice(0, prefixLength)
  return [prefix, payload.slice(0, 3), payload.slice(3, 6), payload.slice(6)].filter((x) => x).join(' ')
}

export function withoutEmptyStrings<T extends object>(obj: T) {
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(obj)) {
    if (value === '') {
      result[key] = null
    } else if (value != null) {
      result[key] = value
    }
  }
  return result as T
}

export function getInitials(fullName?: string): string {
  if (fullName) {
    const nameParts = fullName.trim().split(/\s+/)

    if (nameParts.length === 0) return ''

    const firstNameInitial = nameParts[0].charAt(0).toUpperCase()
    const lastNameInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase()
    return firstNameInitial + lastNameInitial
  }
  return 'NI'
}

export function trimString(str: string, maxLength: number = 50) {
  return str.length > maxLength ? str.substring(0, maxLength) + '...' : str
}
